var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "fade-transition" } }, [
    _vm.isOpen
      ? _c(
          "div",
          {
            staticClass: "vue__lightbox",
            on: {
              click: _vm.close,
              wheel: function ($event) {
                $event.preventDefault()
              },
              touchmove: function ($event) {
                $event.preventDefault()
              },
            },
          },
          [
            _c(
              "div",
              {
                staticClass: "vue__lightbox-content",
                on: { touchstart: _vm.swipeStart, touchmove: _vm.swipe },
              },
              [
                _c("transition", { attrs: { name: "scroll-x-transition" } }, [
                  _c("img", {
                    key: _vm.images[_vm.index].image,
                    staticClass: "vue__lightbox-image",
                    attrs: { src: _vm.images[_vm.index].image },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.next.apply(null, arguments)
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _vm.prevImage !== _vm.index
                  ? _c(
                      "div",
                      {
                        staticClass: "vue__lightbox-control control--prev",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.prev.apply(null, arguments)
                          },
                        },
                      },
                      [_c("i", { staticClass: "icon-arrow-left" })]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.nextImage !== _vm.index
                  ? _c(
                      "div",
                      {
                        staticClass: "vue__lightbox-control control--next",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.next.apply(null, arguments)
                          },
                        },
                      },
                      [_c("i", { staticClass: "icon-arrow-right" })]
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "vue__lightbox-control control--close",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.close.apply(null, arguments)
                  },
                },
              },
              [_c("i", { staticClass: "icon-ui-close" })]
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }